<template>
  <v-snackbar
      v-model="$store.state.other.snackbar.show"
      :color="$store.state.other.snackbar.color"
      :left="$store.state.other.snackbar.x === 'left'"
      :right="$store.state.other.snackbar.x === 'right'"
      :top="$store.state.other.snackbar.y === 'top'"
      :bottom="$store.state.other.snackbar.y === 'bottom'"
      :multi-line="$store.state.other.snackbar.mode === 'multi-line'"
      :vertical="$store.state.other.snackbar.mode === 'vertical'"
      :timeout="$store.state.other.snackbar.timeout"
    >
      {{ $store.state.other.snackbar.text }}
      <v-btn color="white" flat @click="$store.dispatch('setSnackbar', {show: false})" icon><v-icon>close</v-icon></v-btn>
    </v-snackbar>
</template>

<script>
export default {
  name: "Snackbar",
  components: {},
  data() {
    return {
      
    };
  },
  methods: {}

};
</script>

<style scoped>
</style>
